// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/world/CharacterAvatar.css */
.character-label {
  color: #00e5ff;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  text-shadow: 0 0 6px rgba(0, 0, 0, 0.9), 0 0 3px rgba(0, 0, 0, 0.8);
  pointer-events: none;
  user-select: none;
  font-family: system-ui, sans-serif;
  padding: 2px 6px;
  background: rgba(0, 0, 0, 0.55);
  border-radius: 4px;
  border: 1px solid rgba(0, 229, 255, 0.35);
}
`, "",{"version":3,"sources":["webpack://./src/components/world/CharacterAvatar.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mEAAmE;EACnE,oBAAoB;EACpB,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,yCAAyC;AAC3C","sourcesContent":["/* src/components/world/CharacterAvatar.css */\n.character-label {\n  color: #00e5ff;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  text-shadow: 0 0 6px rgba(0, 0, 0, 0.9), 0 0 3px rgba(0, 0, 0, 0.8);\n  pointer-events: none;\n  user-select: none;\n  font-family: system-ui, sans-serif;\n  padding: 2px 6px;\n  background: rgba(0, 0, 0, 0.55);\n  border-radius: 4px;\n  border: 1px solid rgba(0, 229, 255, 0.35);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
